import React from 'react'
import { Col, Container, Row } from 'react-grid-system'
import footerLogo from './footerLogo.png'
import AppIcon from '../../shared/AppIcon'

function FooterSection({
  primaryHeading = 'no Heading',
  secondaryheading = 'no secondary heading',
  tertiaryheading = 'no tertiary heading',

  description = 'no description',
  footerList = []
}) {
  return (
    <div className="footerSection">
      <div className="footerSection__body">
        <Container className="footerSection__container">
          <Row>
            <Col className="footerSection__col" md={12} lg={4}>
              <img
                src={footerLogo}
                alt="Magic Task"
                className="footerSection__logo"
              />

              <div>
                <h3 className="footerSection__heading"> {primaryHeading}</h3>
                <p className="footerSection__desc">{description}</p>
              </div>
            </Col>
            <Col className="footerSection__col" md={12} lg={4}>
              <div className="footerSection__meta">
                <h3 className="footerSection__heading">{secondaryheading}</h3>

                <div className="footerSection__linksWrapper">
                  {footerList.map((item) => (
                    <a
                      key={item.primaryheading}
                      href={item.footerLink || '/'}
                      className="footerSection__link"
                    >
                      {item.primaryheading}
                    </a>
                  ))}
                </div>
              </div>
            </Col>
            <Col className="footerSection__col" md={12} lg={4}>
              <div className="footerSection__social">
                <h3 className="footerSection__heading">{tertiaryheading}</h3>
                <div className="footerSection__socialIcons">
                  <a href="mailto:pperanzo@magictask.io" target={'_blank'}>
                    <AppIcon iconName={'footer_mail'} />
                  </a>
                  <a
                    href="https://www.instagram.com/magictask.io/"
                    target={'_blank'}
                  >
                    <AppIcon iconName={'instaFooter'} />
                  </a>
                  <a href="https://twitter.com/magic_task/" target={'_blank'}>
                    <AppIcon iconName={'twiterFooter'} />
                  </a>

                  <a
                    href="https://www.facebook.com/MagicTask/"
                    target={'_blank'}
                  >
                    <AppIcon iconName={'fbFooter'} />
                  </a>

                  <a
                    href="https://www.linkedin.com/company/magictask"
                    target={'_blank'}
                  >
                    <AppIcon iconName={'linkedInFooter'} />
                  </a>

                  <a
                    href="https://www.youtube.com/channel/UCPoZASfvePWgaBt9ucp9Ilw"
                    target={'_blank'}
                  >
                    <AppIcon iconName={'youtubeFooter'} />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footerSection__copyright">
        © 2021 All RIghts Reserved | Raleigh, North Carolina, USA
      </div>
    </div>
  )
}

export default FooterSection
